import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import selectScoreCardEncryption from './score-card-encryption';
import selectScoreCardSpecialOps from './score-card-special-ops';
import selectScoreCardSurveillance from './score-card-surveillance';
import selectScoreCardDeception from './score-card-deception';
import selectScoreCardMentalHorsepower from './score-card-mental-horsepower';
import selectScoreCardHotRisk from './score-card-hot-risk';
import selectScoreCardPsychometrics from './score-card-psychometrics';

const selectScoreCards = (
  attributes,
  phrases,
  specialOpsVideoUrl,
  specialOpsVideoPagePath,
  remainingChallenges,
) => {
  if (isEmpty(attributes)) return null;

  return compact([
    selectScoreCardSpecialOps(attributes, phrases, specialOpsVideoUrl, specialOpsVideoPagePath),
    selectScoreCardEncryption(attributes, phrases),
    selectScoreCardSurveillance(attributes, phrases),
    selectScoreCardDeception(attributes, phrases),
    selectScoreCardMentalHorsepower(attributes, phrases, remainingChallenges),
    selectScoreCardHotRisk(attributes, phrases, remainingChallenges),
    selectScoreCardPsychometrics(attributes, phrases, remainingChallenges),
  ]);
};

export default selectScoreCards;
